export enum AlertType {
  PACY_V0USAGE = "PACY_V0USAGE",
}
